import React from 'react';
import PropTypes from 'prop-types';
import makeRef from 'lib/makeRef';

export default class PassageCorrectionPopover extends React.Component {
  static propTypes = {
    activeIndex: PropTypes.number,
    anchorNode: PropTypes.any, // DOM node,
    rendererWrapperNode: PropTypes.any, // DOM node,
    onReset: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node])
  };

  static defaultProps = {
    onReset: () => {}
  };

  constructor(props) {
    super(props);
    this.wrapperNode = null;
  }

  componentDidMount() {
    global.addEventListener('click', this.handleClickOutsideComponent);
    global.addEventListener('keydown', this.handleEscapeKeyPress);
    this.positionPopoverHandler();
  }

  componentDidUpdate(prevProps) {
    this.positionPopoverHandler(prevProps.anchorNode);
  }

  componentWillUnmount() {
    global.removeEventListener('scroll', this.positionPopover);
    global.removeEventListener('click', this.handleClickOutsideComponent);
    global.removeEventListener('keydown', this.handleEscapeKeyPress);
  }

  handleClickOutsideComponent = (e) => {
    if (
      this.props.rendererWrapperNode &&
      this.isActive() &&
      !this.props.rendererWrapperNode.contains(e.target)
    ) {
      this.props.onReset();
    }
  };

  handleEscapeKeyPress = (e) => {
    if (e.key === 'Escape' && this.isActive()) {
      this.props.onReset();
    }
  };

  positionPopoverHandler(previousAnchorNode = null) {
    if (!this.isActive()) {
      global.removeEventListener('scroll', this.positionPopover);
      return;
    }

    if (previousAnchorNode !== this.props.anchorNode) {
      global.removeEventListener('scroll', this.positionPopover);
      this.positionPopover();
      global.addEventListener('scroll', this.positionPopover, true);
    }
  }

  positionPopover = () => {
    const anchorRect = this.props.anchorNode.getBoundingClientRect();
    const popoverRect = this.wrapperNode.getBoundingClientRect();

    const popoverWidth = popoverRect.width || 250;
    const margin = 8;
    const viewportWidth = window.innerWidth;

    this.wrapperNode.style.position = 'fixed';
    this.wrapperNode.style.top = `${anchorRect.bottom}px`;
    this.wrapperNode.style.left = 'auto';
    this.wrapperNode.style.right = 'auto';

    const rightAlignedLeft = anchorRect.right - popoverWidth;
    if (rightAlignedLeft >= margin) {
      // Right-aligned fits
      this.wrapperNode.style.right = `${viewportWidth - anchorRect.right}px`;
    } else if (anchorRect.left + popoverWidth <= viewportWidth - margin) {
      // Left-aligned fits
      this.wrapperNode.style.left = `${Math.max(margin, anchorRect.left)}px`;
    } else {
      // fallback if neither fits
      const constrainedLeft = Math.max(
        margin,
        Math.min(anchorRect.left, viewportWidth - popoverWidth - margin)
      );
      this.wrapperNode.style.left = `${constrainedLeft}px`;
    }
  };

  isActive() {
    return Boolean(this.props.activeIndex !== null && this.props.anchorNode);
  }

  makeRef = makeRef.bind(this);

  render() {
    if (!this.isActive()) {
      return null;
    }
    const {children, anchorNode} = this.props;
    return (
      <div
        className='passage-correction-popover card card--no-padding no-arrow'
        ref={this.makeRef}
        data-ref-name='wrapperNode'
      >
        {typeof children === 'function'
          ? children({
              anchorNode
            })
          : children}
      </div>
    );
  }
}
